import Vue from 'vue';
import capitalize from 'lodash/capitalize';
import VueApollo from 'vue-apollo';
import { VueHammer } from 'vue2-hammer';
import graph from './graph';
import App from './App.vue';
import router from './router';
import store from './store';
import PortalVue from 'portal-vue';

Vue.config.productionTip = false;

Vue.use(VueApollo);
Vue.use(VueHammer);
Vue.use(PortalVue);

VueHammer.config.press = {
  time: 0,
  threshold: 50
};
VueHammer.config.pressUp = {
  time: 0,
  threshold: 50
};

Vue.filter('capitalize', function(value) {
  return capitalize(value);
});

new Vue({
  router,
  store,
  apolloProvider: graph.setupProvider(),
  apollo: {},
  render: h => h(App)
}).$mount('#app');
